import CountryFlag from '@/components/CountryFlag';
import { countriesOptions } from '@/helpers/countries';
import SelectBoxControl from './SelectBoxControl';

export default function CountryFieldControl({
  onChange,
  name,
  setFieldValue,
  validateForm,
  ...props
}) {
  return (
    <SelectBoxControl
      options={countriesOptions()}
      onChange={(selected) => setFieldValue(name, selected)}
      onBlur={() => validateForm(name)}
      {...props}
    />
  );
}
